// @ts-check
import api from 'utils/api';
import { decamelizeKeys } from 'humps';
import buildFormDataFromNestedJSON from 'utils/buildFormDataFromNestedJSON';
import uid from 'uid';
import { receiveCurrentAgent } from 'agent_portal/actions/CurrentAgentActions';

const refreshReduxCurrentAgent = dispatch => {
  api.get(`/agent_portal/api/current_agent.json?uid=${uid()}`).then(response => {
    dispatch(receiveCurrentAgent(response.data.currentAgent));
  });
};

const actions = {
  fetchCurrentAgent() {
    return api.get('/agent_portal/api/current_agent/edit').then(response => response.data);
  },

  updateCurrentAgent(formValues, dispatch) {
    return api
      .put('/agent_portal/api/current_agent', {
        agent: decamelizeKeys(formValues),
      })
      .then(response => {
        refreshReduxCurrentAgent(dispatch);
        return response;
      });
  },

  updateAvatar(formValues) {
    // FIXME: This assumes we have a browser with FormData, which means IE10+

    // Handle FileList conversion
    // image can be absent
    // image can be FileList with no entries
    // image can be FileList with 1 entry
    const { image, ...adjustedFormValues } = formValues;
    if (image && image.length === 1) {
      adjustedFormValues.image = image[0];
    }
    const formData = buildFormDataFromNestedJSON(adjustedFormValues, 'provider');
    return api.patch(`/agent_portal/api/current_agent/update_avatar`, formData);
  },
};

export default actions;
